var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.2428C8.20109 6.2428 6.33081 8.12794 6.33081 10.4451C6.33081 12.7623 8.20109 14.6474 10.5 14.6474C12.7989 14.6474 14.6692 12.7623 14.6692 10.4451C14.6692 8.12794 12.7989 6.2428 10.5 6.2428ZM12.9814 10.4451C12.9814 11.824 11.868 12.9463 10.5 12.9463C9.13204 12.9463 8.01858 11.824 8.01858 10.4451C8.01858 9.06629 9.13204 7.94398 10.5 7.94398C11.868 7.94398 12.9814 9.06629 12.9814 10.4451Z",
    fill: "#726FB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7338 9.49836C20.6132 9.29584 19.5098 7.47821 17.7802 5.70614C15.3791 3.2472 12.9295 2 10.5 2C4.76527 2 0.447058 9.19627 0.266225 9.50174C-0.0887418 10.0992 -0.0887418 10.9042 0.266225 11.5033C0.38678 11.7042 1.49019 13.5218 3.21982 15.2939C5.62087 17.7528 8.06881 19 10.5 19C16.2331 19 20.5529 11.8037 20.7338 11.4983C21.0887 10.9008 21.0887 10.0958 20.7338 9.49836ZM19.1833 10.565C19.0226 10.835 15.2134 17.1807 10.5 17.1807C8.5728 17.1807 6.55685 16.1158 4.50742 14.018C2.92178 12.3927 1.92386 10.7506 1.81502 10.5684C1.79828 10.5413 1.79828 10.4637 1.81502 10.435C1.85856 10.3625 2.88327 8.63933 4.51579 6.97022C5.92059 5.53231 8.09895 3.81932 10.4983 3.81932C12.4255 3.81932 14.4415 4.88424 16.4909 6.98203C18.0749 8.60558 19.0745 10.2511 19.1833 10.4316C19.2 10.4587 19.2 10.5363 19.1833 10.5633V10.565Z",
    fill: "#726FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.22144e5a9cc29c0fda118c67f54c4ad7.svg";
export { ForwardRef as ReactComponent };